export const EMPTY_SIMULATION_NAME = 'empty-simulation';
export const EMPTY_SIMULATION_ID = '_empty_';
export const EMPTY_SIMULATION_SET_SUFFIX = 'empty-sim-set';

export const buildEmptySimulationSetId = (geodataId: string): string => `${geodataId}-${EMPTY_SIMULATION_SET_SUFFIX}`;

export const buildEmptyLayerIdForSimulationSet = (simulationSetId: string): string => `${simulationSetId}-${EMPTY_SIMULATION_ID}`;

export const buildEmptyLayerIdForGeodata = (geodataId: string): string =>
    buildEmptyLayerIdForSimulationSet(buildEmptySimulationSetId(geodataId));

type SimulationLike = {
    id?: string | number | null;
    name?: string | null;
};

export const hasRealSimulations = (simulations: SimulationLike[] | undefined | null): boolean =>
    (simulations ?? []).some((simulation) => simulation?.name !== EMPTY_SIMULATION_NAME);
